<template>
  <div id="ag-grid-demo">
    <vx-card>
<!--      &lt;!&ndash; Per Page &ndash;&gt;-->
<!--      <div class="mb-4 md:mb-0">-->
<!--        <per-page-->
<!--          :currentPerPage="per_page"-->
<!--          :pageStart="pageStart"-->
<!--          :pageEnd="pageEnd"-->
<!--          :total="total"-->
<!--          @change-per-page="ChangePerPage($event)"-->
<!--        />-->
<!--      </div>-->

      <!-- Table -->
      <ag-grid-vue
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :rowData="list"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      >
      </ag-grid-vue>

      <!-- Pagination -->
      <vs-pagination
        :total="totalPages"
        :max="maxPageNumbers"
        v-model="Page" />
    </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'
import axios from '@/axios.js'
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import {format} from "date-fns";
export default {
  mixins: [TableMixin],
  components: {
    AgGridVue
  },
  data() {
    return {
      // table header value
      maxPageNumbers: 7,
      columnDefs: [
        {
          headerName: 'Created On',
          field: 'created_on',
            minWidth: 260,
        },
        {
          headerName: 'Amount',
          field: 'amount',
            minWidth: 120
        },
        {
          headerName: 'Invoice Number',
          field: 'invoice_number',
            minWidth: 350
        },
        {
          headerName: 'Method',
          field: 'method',
            minWidth: 250
        },
        {
          headerName: 'Tran Id',
          field: 'tran_id',
            minWidth: 230
        },
        {
          headerName: 'Status',
          field: 'status',
            minWidth: 250
        }
      ],
      list: [],

      components: {
      },
    }
  },
  methods: {
    GetList() {
      this.$vs.loading()
      this.$store.dispatch('payment/GetList', {
        ...this.filters,
        page: this.Page - 1 || 0,
        per_page:  10,
        order_by: 'created_on',
        order_dir: 'desc',
      })
        .then(res => {
          this.list = res.items.map(this.TransformList)
          this.total = res.total
        })
        .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
        .finally(() => this.$vs.loading.close())
    },
    Capitalize (val) {
      if (!val) return ''
      return `${val.charAt(0).toUpperCase()}${val.slice(1)}`
    },
    TransformList(item) {
      return {
        created_on: item.created_on && format(new Date(item.created_on), 'yyyy:MM:dd HH:mm:ss'),
        created_by: item.created_by,
        amount: `$${item.amount}`,
        invoice_number: item.invoice_number,
        method: this.Capitalize(item.method),
        tran_id: item.tran_id
      }
    }
  },
  created() {
    this.GetList()
  }
}
</script>

<style scoped>

</style>
